import React from 'react'
import moment from 'moment'
import {
  MenuItem,
  Menu,
  makeStyles,
  CircularProgress,
  useMediaQuery
} from '@material-ui/core'
import { KeyboardArrowDown } from '@material-ui/icons'

import AnnouncementsSVG from '../../assets/icons/announcements.svg'
import PhotoSVG from '../../assets/icons/photo.svg'
import emptyDataPreviewSVG from '../../assets/icons/homepage-empty-preview.svg'
import EventsSVG from '../../assets/icons/events.svg'

import Slider from 'react-slick'
import { DateObject } from 'react-multi-date-picker'

import StyledSVG from '../shared/StyledSVG'
import UserAvatar from '../shared/UserAvatar'
import { occupationsObject } from '../../utils/dicts'
import { extractMonth } from '../../utils/extractDate'

const useSyles = makeStyles(theme => ({
  root: {
    width: '100%'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 10,
    '& .title': {
      fontWeight: 600,
      fontSize: 28,
      margin: '0px 0px 0px 9px',
      color: '#386093'
    }
  },
  main: {
    '& .slick-slide': {
      padding: '0px 10px 0px 10px',
      width: 380
    },
    '& .slick-list': {
      width: '100%',
      margin: '0px 10px 0px 0px'
    },
    '& .slick-dots': {
      bottom: '-30px'
    }
  },
  empty_comments_wrapper: {
    width: '100%',
    minHeight: 355,
    backgroundColor: '#FFFFFF',
    borderRadius: 16
  },
  month_select: {
    width: 130,
    height: 48,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    borderRadius: 8,
    backgroundColor: '#FFFFFF',
    color: '#ADB8CC',
    border: '1px solid #ADB8CC',
    padding: '12px 16px',
    marginRight: 10,
    '& p': {
      margin: 0
    },
    '& .MuiSvgIcon-root': {
      fill: '#ADB8CC'
    }
  },
  rotate_arrow: {
    transform: 'rotate(180deg)'
  },
  arrow_root: {
    transition: 'transform 0.3s ease-in-out'
  },
  menu_options: {
    '& .MuiMenu-paper': {
      maxHeight: 200
    }
  },
  comment_card: {
    cursor: 'pointer',
    position: 'relative',
    padding: 24,
    borderRadius: 16,
    minHeight: 350,
    backgroundColor: '#FFFFFF'
  },
  avatar_section: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 4
  },
  user_infos: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    '& .name': {
      fontSize: 18,
      margin: 0
    },
    '& .occupation': {
      fontSize: 14,
      margin: 0
    }
  },
  comment_overview: {
    marginTop: 16,
    color: '#9B9B9B',
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    '& p': {
      margin: 0
    },
    '& .contrast': {
      color: '#386093',
      fontFamily: 'Montserrat',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: 'normal',
      textDecorationLine: 'underline',
      textDecorationStyle: 'solid',
      textDecorationSkipInk: 'none',
      textDecorationThickness: 'auto',
      textUnderlineOffset: 'auto',
      textUnderlinePosition: 'from-font'
    }
  },
  comment_content: {
    wordBreak: 'break-word',
    '& i': {
      color: '#555',
      fontFamily: 'Montserrat',
      fontSize: '16px',
      fontStyle: 'italic',
      fontWeight: 500,
      lineHeight: '150%',
      display: '-webkit-box',
      WebkitLineClamp: 4,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden'
    }
  },
  comment_card_footer: {
    position: 'absolute',
    width: '89%',
    bottom: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& .created_at': {
      wordBreak: 'break-word',
      margin: 0
    }
  },
  event_type: {
    borderRadius: 32,
    padding: '7px 14px',
    display: 'flex',
    gap: 8,
    alignItems: 'center',
    '& .label': {
      color: '#386093',
      fontWeight: 600,
      fontSize: 14,
      margin: 0
    }
  },
  empty_comments: {
    paddingTop: 32,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    rowGap: 32,
    '& .description': {
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      rowGap: 8,
      '& h1': {
        margin: 0,
        color: '#386093',
        fontSize: 24
      },
      '& p': {
        margin: 0,
        fontWeight: 400,
        fontSize: 16
      }
    }
  },
  slider_root_skelteton: {
    height: 433,
    width: '100%',
    backgroundColor: '#fff',
    borderRadius: 16,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}))

const EventCommentSlider = ({
  eventComments,
  getEventComments,
  history,
  currentSchool
}) => {
  const classes = useSyles()
  const months = [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro'
  ]
  const [isDragging, setIsDragging] = React.useState(false)
  const currentDate = new DateObject()
  const [filterDate, setFilterDate] = React.useState({
    label: months[currentDate.month.index],
    updatedDate: currentDate
  })
  const [openSelect, setOpenSelect] = React.useState(false)
  const [anchorEl, setAnchorEl] = React.useState(null)
  const isMobile = useMediaQuery('(max-width:880px)')
  const isTablet = useMediaQuery('(max-width:1400px)')
  const slidesToShow = isMobile ? 1 : isTablet ? 2 : 2
  const emptyComments =
    !eventComments.isFetching && eventComments.items.length === 0

  const formatDateLabel = dateString => {
    const date = moment(dateString, 'YYYY-MM-DD HH:mm')
    if (date.isSame(moment(), 'day')) {
      return `Hoje, ${date.format('HH:mm')}`
    } else if (date.isSame(moment().subtract(1, 'day'), 'day')) {
      return `Ontem, ${date.format('HH:mm')}`
    } else {
      return date.format('ll')
    }
  }

  const handleClickItem = (e, eventId) => {
    if (isDragging) {
      e.preventDefault()
      e.stopPropagation()
      return
    }
    history.push(`/announcements?id=${eventId}&name=view`)
  }

  const getEventIcon = eventType => {
    if (eventType === 'events') {
      return { icon: EventsSVG, label: 'Evento', bgColor: '#EBF3FC' }
    } else if (eventType === 'communications') {
      return {
        icon: AnnouncementsSVG,
        label: 'Comunicado',
        bgColor: '#D9E8FA80'
      }
    } else if (eventType === 'images') {
      return { icon: PhotoSVG, label: 'Mídia', bgColor: '#E8E8DB80' }
    }
  }

  const handleOpenSelectMonth = event => {
    setAnchorEl(event.currentTarget)
    setOpenSelect(!openSelect)
  }

  const handleChangeMonth = monthIdx => {
    const updatedMonth = new DateObject({
      day: currentDate.day,
      month: monthIdx + 1,
      year: currentDate.year
    })
    setFilterDate({
      label: months[updatedMonth.month.index],
      updatedDate: updatedMonth
    })
  }
  React.useEffect(
    () => {
      const { beginningOfMonth, endOfMonth } = extractMonth(
        filterDate.updatedDate
      )
      getEventComments({
        params: {
          'q[event_created_at_gteq]': beginningOfMonth,
          'q[event_created_at_lteq]': endOfMonth,
          'q[event_school_id_eq]': currentSchool?.id,
          'page[size]': 10,
          include:
            'event.user,user.user_occupations.occupation,event.destinations'
        }
      })
    },
    [filterDate]
  )

  if (eventComments.isFetching) {
    return (
      <div className={classes.slider_root_skelteton}>
        <CircularProgress />
      </div>
    )
  }
  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <h1 className='title'>Últimos comentários</h1>
        <div className={classes.month_select} onClick={handleOpenSelectMonth}>
          <p>{filterDate.label}</p>
          <KeyboardArrowDown
            className={`${classes.arrow_root} ${
              openSelect ? classes.rotate_arrow : ''
            }`}
          />
          <Menu
            id='select-month-popover'
            anchorEl={anchorEl}
            className={classes.menu_options}
            keepMounted
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right'
            }}
            open={openSelect}
            onClose={() => setOpenSelect(false)}
            getContentAnchorEl={null}
          >
            {months.map((month, index) => {
              return (
                <MenuItem
                  onClick={() => handleChangeMonth(index)}
                  key={month}
                  value={index}
                >
                  {month}
                </MenuItem>
              )
            })}
          </Menu>
        </div>
      </div>
      <div
        className={`${classes.main} ${emptyComments &&
          classes.empty_comments_wrapper}`}
      >
        {emptyComments ? (
          <div className={classes.empty_comments}>
            <StyledSVG src={emptyDataPreviewSVG} width={300} height={180} />
            <div className='description'>
              <h1>Nenhum comentário disponível no momento</h1>
              <p>Ainda não há comentários registrados neste mês.</p>
            </div>
          </div>
        ) : (
          <Slider
            infinite={false}
            dots
            slidesToShow={slidesToShow}
            slidesToScroll={slidesToShow}
            beforeChange={() => setIsDragging(true)}
            afterChange={() => setIsDragging(false)}
          >
            {eventComments.items?.map(comment => {
              const eventFooterInfo = getEventIcon(comment.event.event_type)
              return (
                <div
                  onClick={event => handleClickItem(event, comment.event_id)}
                  key={comment.id}
                  className={classes.comment_card}
                >
                  <div className={classes.avatar_section}>
                    <UserAvatar
                      avatarStyle={{ width: 50, height: 50 }}
                      avatarUrl={comment?.user?.avatar_url}
                      userName={comment?.user?.name}
                      withoutUserName
                    />
                    <div className={classes.user_infos}>
                      <h1 className='name'>{comment?.user?.name}</h1>
                      <p className='occupation'>
                        {
                          occupationsObject[
                            comment?.user?.user_occupations?.[0].occupation.name
                          ]
                        }
                      </p>
                    </div>
                  </div>
                  <div className={classes.comment_overview}>
                    <p>
                      comentou em{' '}
                      <span className='contrast'>
                        &quot;{comment.event.title}&quot;
                      </span>
                    </p>
                    <p>Criado por {comment.event.user.name}</p>
                  </div>
                  <p className={classes.comment_content}>
                    <i>{comment.content}</i>
                  </p>
                  <div className={classes.comment_card_footer}>
                    <p className='created_at'>
                      {formatDateLabel(comment.created_at)}
                    </p>
                    <div
                      className={classes.event_type}
                      style={{ backgroundColor: eventFooterInfo.bgColor }}
                    >
                      <StyledSVG
                        src={eventFooterInfo.icon}
                        height={20}
                        width={20}
                      />
                      <p className='label'>{eventFooterInfo.label}</p>
                    </div>
                  </div>
                </div>
              )
            })}
          </Slider>
        )}
      </div>
    </div>
  )
}

export default EventCommentSlider
